var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "paint-brush-solid",
    className: "cls-1",
    d: "M11.734,21.75A7.116,7.116,0,0,0,4.9,26.834a1.073,1.073,0,0,1-1.026.7c-.781,0-3.2-1.946-3.885-2.415,0,5.79,2.668,10.879,9,10.879,5.334,0,9-3.078,9-8.451a6.092,6.092,0,0,0-.068-.642L11.734,21.75ZM32.185,0a4.294,4.294,0,0,0-2.827,1.157C14.986,14,13.49,14.3,13.49,18.077A6.51,6.51,0,0,0,14.1,20.8l4.487,3.739a6.47,6.47,0,0,0,1.574.213c4.367,0,6.9-3.2,14.847-18.032a7.235,7.235,0,0,0,.977-3.234A3.661,3.661,0,0,0,32.185,0Z",
    transform: "translate(0.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiWhite);
export default __webpack_public_path__ + "static/media/ui-white.cfcc5bb3423db0977c221974beb0301f.svg";
export { ForwardRef as ReactComponent };